// SYNC with ./Layout/styles.module.scss
// export const SINGLE_NAV_BREAKPOINT = 840;
export const TWO_COLUMN_LAYOUT = 960;
export default {
  twoColumnLayout: TWO_COLUMN_LAYOUT
};